import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import { stylingHelpers } from '../../designTokens';
import ColorProvider from '../chrome/ColorProvider';
import Heading from '../chrome/Heading';
import Text from '../chrome/Text';

const { flexStack } = stylingHelpers;

const baseStyles = () => css`
  ${flexStack()}
  align-items: center;
`;

const Container = styled('div')(baseStyles);

const subTextBaseStyles = ({ theme }) => css`
  margin-top: -${theme.spacings.byte};
`;

const SubText = styled('div')(subTextBaseStyles);

const Date = ({ variant, title, subText }) => (
  <Container>
    <ColorProvider variant={variant}>
      <Heading as='h3' size='peta' bold italic upper noMarginBoth>
        {title}
      </Heading>
    </ColorProvider>
    <SubText>
      <Text size='giga' bold italic upper noMargin>
        {subText}
      </Text>
    </SubText>
  </Container>
);

Date.propTypes = {
  variant: PropTypes.string,
  title: PropTypes.number,
  subText: PropTypes.string,
};

Date.defaultProps = {
  variant: 'red',
  title: 90,
  subText: 'Days',
};

export default Date;
